import type {GlobalState} from 'types/store';

export const isAppVisible = (state: GlobalState) => state.appVisibility.visible;
